<template>
    <section>
        <!--工具条-->
        <!--<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>-->
        <el-col v-if="buttonList!=null&&buttonList.length>0" :span="24" class="toolbar" style="padding-bottom: 10px;">
            <el-select v-model="SelStatus" placeholder="请选择状态" filterable>
                <el-option :key="0" :value="-1" :label="'全部状态'"></el-option>
                <el-option v-for="item in orderStatus"
                           :key="'Status'+item.StatusCode"
                           :label="item.StatusName"
                           :value="item.StatusCode">
                    <span style="float: left">{{ item.StatusName }}</span>
                </el-option>
            </el-select>
            <el-select v-model="SelPayType" placeholder="请选择支付类型" filterable>
                <!--<el-option :key="0" :value="0" :label="'全部支付类型'"></el-option>-->
                <el-option v-for="item in payTypes"
                           :key="'Status'+item.StatusCode"
                           :label="item.StatusName"
                           :value="item.StatusCode">
                    <span style="float: left">{{ item.StatusName }}</span>
                </el-option>
            </el-select>
            <el-select v-model="SelGoodsNames" placeholder="物品名称" filterable>
                <el-option :key="0" :value="0" :label="'全部物品'"></el-option>
                <el-option v-for="item in allGoodsNames"
                           :key="'GoodsName'+item.Id"
                           :label="item.Name"
                           :value="item.Id">
                    <span style="float: left">{{ item.Name }}</span>
                </el-option>
            </el-select>
            <el-select v-model="SelRefundStatus" placeholder="退款状态" filterable>
                <!--<el-option :key="0" :value="-1" :label="'全部状态'"></el-option>-->
                <el-option v-for="item in refundOrderStatus"
                           :key="'RefundStatus'+item.StatusCode"
                           :label="item.StatusName"
                           :value="item.StatusCode">
                    <span style="float: left">{{ item.StatusName }}</span>
                </el-option>
            </el-select>
            <el-select v-model="SelCourierId" placeholder="请选择驾驶员" filterable>
                <el-option :key="0" :value="0" :label="'全部驾驶员'"></el-option>
                <el-option v-for="item2 in allCouriers"
                           :key="'Product'+item2.Id"
                           :label="item2.Name"
                           :value="item2.Id">
                    <span style="float: left">{{ item2.Name }}</span>
                </el-option>
            </el-select>

            <el-select v-model="IsSendInvoice" placeholder="是否开票" filterable>
                <el-option :key="0" value="-1" :label="'全部'"></el-option>
                <el-option :key="1" value="1" :label="'已开票'"></el-option>
                <el-option :key="2" value="0" :label="'未开票'"></el-option>
            </el-select>
            <el-date-picker type="date" placeholder="开始时间" v-model="StartTime" value-format="yyyy-MM-dd"></el-date-picker>
            <el-date-picker type="date" placeholder="结束时间" v-model="EndTime" value-format="yyyy-MM-dd"></el-date-picker>
            <el-input v-model="SelUserName" placeholder="会员Id" style="width:200px;margin-left:10px;"></el-input>
            <el-input v-model="searchVal" placeholder="请输入订单号" style="width:200px;margin-left:10px;"></el-input>
            <el-button type="primary" @click="handleQuery">查询</el-button>
            <!--<toolbar :buttonList="buttonList" @callFunction="callFunction"></toolbar>-->
            <el-button @click="ExportExcel" class="el-button el-button--primary el-button--medium" v-if="isExport" style="margin-left:10px;">导出Excel</el-button>
        </el-col>

        <!--列表-->
        <el-table :data="OrderStatistics"
                  ref="table1"
                  class="custom-tbl"
                  style="width: 99%;height:150px;">
            <!--<el-table-column type="selection" width="50"> </el-table-column>-->
            <!--<el-table-column type="index" :index="indexMethod" label="序号" width="50" fixed> </el-table-column>-->
            <el-table-column label="订单总数量" prop="OrderCount" width="" sortable>
            </el-table-column>
            <el-table-column label="物品总数量" prop="GoodsSum" width="" sortable>
            </el-table-column>
            <el-table-column label="订单总金额" prop="AmountSum" width="" sortable>
            </el-table-column>
            <el-table-column label="微信订单数量" prop="WeChatOrderCount" width="" sortable>
            </el-table-column>
            <el-table-column label="微信订单金额" prop="WeChatAmountSum" width="" sortable>
            </el-table-column>
            <el-table-column label="余额订单数量" prop="RechargeOrderCount" width="" sortable>
            </el-table-column>
            <el-table-column label="余额订单金额" prop="RechargeAmountSum" width="" sortable>
            </el-table-column>
        </el-table>

        <!--列表-->
        <el-table :data="OrderStatisticsByCourierList"
                  v-loading="listLoading"
                  @select="dialogCheck"
                  @row-click="selectCurrentRow"
                  ref="table2"
                  class="custom-tbl"
                  style="width: 99%; height: 400px; overflow-y: scroll; ">
            <!--<el-table-column type="selection" width="50"> </el-table-column>-->
            <el-table-column type="index" :index="indexMethod" label="序号" width="50" fixed> </el-table-column>
            <!--<el-table-column prop="CourierId" label="驾驶员Id" width="190px" sortable fixed>
    </el-table-column>-->
            <el-table-column prop="CourierName" label="驾驶员姓名" width="" sortable fixed>
            </el-table-column>
            <el-table-column prop="OrderCount" label="接单总数量" width="" sortable fixed>
            </el-table-column>
            <el-table-column label="物品总数量" prop="GoodsSum" width="" sortable>
            </el-table-column>
            <el-table-column prop="AmountSum" label="接单总金额" width="" sortable>
            </el-table-column>
            <el-table-column label="微信订单数量" prop="WeChatOrderCount" width="" sortable>
            </el-table-column>
            <el-table-column label="微信订单金额" prop="WeChatAmountSum" width="" sortable>
            </el-table-column>
            <el-table-column label="余额订单数量" prop="RechargeOrderCount" width="" sortable>
            </el-table-column>
            <el-table-column label="余额订单金额" prop="RechargeAmountSum" width="" sortable>
            </el-table-column>
        </el-table>


        <el-table :data="OrderStatisticsByGoodsNameList"
                  v-loading="listLoading"
                  @select="dialogCheck"
                  @row-click="selectCurrentRow"
                  ref="table3"
                  class="custom-tbl"
                  style="width: 99%; height: 600px; overflow-y: scroll; ">
            <!--<el-table-column type="selection" width="50"> </el-table-column>-->
            <el-table-column type="index" :index="indexMethod" label="序号" width="50" fixed> </el-table-column>
            <!--<el-table-column prop="GoodsNameId" label="物品名称Id" width="190px" sortable fixed>
    </el-table-column>-->
            <el-table-column prop="GoodsName" label="物品名称" width="" sortable fixed>
            </el-table-column>
            <el-table-column prop="OrderCount" label="接单总数量" width="" sortable fixed>
            </el-table-column>
            <el-table-column label="物品总数量" prop="GoodsSum" width="" sortable>
            </el-table-column>
            <el-table-column prop="AmountSum" label="接单总金额" width="" sortable>
            </el-table-column>
            <el-table-column label="微信订单数量" prop="WeChatOrderCount" width="" sortable>
            </el-table-column>
            <el-table-column label="微信订单金额" prop="WeChatAmountSum" width="" sortable>
            </el-table-column>
            <el-table-column label="余额订单数量" prop="RechargeOrderCount" width="" sortable>
            </el-table-column>
            <el-table-column label="余额订单金额" prop="RechargeAmountSum" width="" sortable>
            </el-table-column>
        </el-table>

        <!--列表-->
        <el-table :data="OrderStatisticsByStatusList"
                  v-loading="listLoading"
                  @select="dialogCheck"
                  @row-click="selectCurrentRow"
                  ref="table"
                  class="custom-tbl"
                  style="width: 99%;height:400px;">
            <!--<el-table-column type="selection" width="50"> </el-table-column>-->
            <el-table-column type="index" :index="indexMethod" label="序号" width="50" fixed> </el-table-column>
            <!--<el-table-column prop="Status" label="状态Id" width="190px" sortable fixed>
    </el-table-column>-->
            <el-table-column prop="StatusName" label="状态名称" width="" sortable fixed>
            </el-table-column>
            <el-table-column prop="OrderCount" label="接单总数量" width="" sortable fixed>
            </el-table-column>
            <el-table-column label="物品总数量" prop="GoodsSum" width="" sortable>
            </el-table-column>
            <el-table-column prop="AmountSum" label="接单总金额" width="" sortable>
            </el-table-column>
            <el-table-column label="微信订单数量" prop="WeChatOrderCount" width="" sortable>
            </el-table-column>
            <el-table-column label="微信订单金额" prop="WeChatAmountSum" width="" sortable>
            </el-table-column>
            <el-table-column label="余额订单数量" prop="RechargeOrderCount" width="" sortable>
            </el-table-column>
            <el-table-column label="余额订单金额" prop="RechargeAmountSum" width="" sortable>
            </el-table-column>
        </el-table>

        <!--工具条-->
        <!--<el-col :span="24" class="toolbar">
        <el-pagination layout="prev, pager, next"
                       @current-change="handleCurrentChange"
                       :page-size="50"
                       :total="total"
                       style="float: right">
        </el-pagination>
    </el-col>-->

    </section>
</template>

<script>
    import util from "../../../util/date";
    import {
        getOrderStatistics,
        getAllCourier,
        getAllTimePeriod,
        getAllGoodsName,
        getAllUserAddress,
        getAllUserCoupon
        //UpdateOrderDelivery,
        /* exportOrders*/
    } from "../../api/api";
    import { getButtonList } from "../../promissionRouter";
    /*import Toolbar from "../../components/Toolbar";*/
    //import global from '../../components/Global'//引用全局模块
    //import moment from 'moment'

    export default {
        /* components: { Toolbar },*/
        data() {
            return {
                filters: {
                    name: "",
                },
                tableHeight: 600,
                activeNames: ['1'],
                searchVal: "",
                OrderStatistics:[],
                //members: {
                //    OrderCount: 0,
                //    AmountSum: 0,
                //    WeChatOrderCount: 0,
                //    WeChatAmountSum: 0,
                //    RechargeOrderCount: 0,
                //    RechargeAmountSum: 0
                //},
                total: 0,
                buttonList: [],
                currentRow: null,
                page: 1,
                listLoading: false,
                StartTime: "",
                EndTime: "",
                orderStatus: [{ StatusName: '未付款', StatusCode: 0 }, { StatusName: '已付款', StatusCode: 1 }, { StatusName: '已接单', StatusCode: 2 }, { StatusName: '已取货', StatusCode: 3 }, { StatusName: '已完成', StatusCode: 4 }, { StatusName: '已取消', StatusCode: 10 }],
                //refundOrderStatus: [{ StatusName: '全部', StatusCode: -1 }, { StatusName: '未退款', StatusCode: 0 }, { StatusName: '全额退款', StatusCode: 1 }, { StatusName: '部分退款', StatusCode: 2 }],
                refundOrderStatus: [{ StatusName: '全部', StatusCode: -1 }, { StatusName: '未退款', StatusCode: 0 }, { StatusName: '已退款', StatusCode: 1 }],
                applyRefundStatus: [{ StatusName: '全部', StatusCode: -1 }, { StatusName: '未申请', StatusCode: 0 }, { StatusName: '待审核', StatusCode: 1 }, { StatusName: '审核通过', StatusCode: 2 }, { StatusName: '审核不通过', StatusCode: 3 }],
                payTypes: [{ StatusName: '全部', StatusCode: 0 }, { StatusName: '余额支付', StatusCode: 1 }, { StatusName: '微信支付', StatusCode: 2 }],
                SelPayType:0,
                SelStatus: -1,
                SelRefundStatus: -1,
                SelCourierId: 0,
                SelGoodsNames: 0,

                allTimePeriods: [],//所有预约时段
                allUserAddress: [],//用户的所有地址
                deliveryPicturesList: [],//送达拍照
                senderPicturesList: [],//发件拍照
                allGoodsNames: [],//物品名称
                allUserCoupons: [],//用户优惠券

                //SelStoreId: 0,
                editFormVisible: false, //编辑界面是否显示
                editLoading: false,
                SearchType: 0,
                isEdit: false,
                isDelete: false,
                isExport: false,

                allCouriers: [],

                IsSendInvoice: "-1",
                SelUserName: "",


                OrderStatisticsByCourierList: [],
                OrderStatisticsByGoodsNameList: [],
                OrderStatisticsByStatusList: [],

            };
        },
        methods: {
            indexMethod(index) {
                index = (index + 1) + (this.page - 1) * 20;
                //index = this.total - (this.page - 1) * 20 - index
                return index;
            },
            onEditorReady(editor) { },
            dialogCheck(selection, row) {
                this.currentRow = null;
                this.$refs.table.clearSelection();
                if (selection.length === 0) {
                    return;
                }
                if (row) {
                    this.selectCurrentRow(row);
                }
            },
            selectCurrentRow(val) {
                if (val) {
                    this.currentRow = val;
                    this.$refs.table.clearSelection();
                    this.$refs.table.toggleRowSelection(val, true);
                }
            },
            callFunction(item) {
                this.filters = {
                    name: item.search,
                };
                this[item.Func].apply(this, item);
            },
            handleCurrentChange(val) {
                this.page = val;
                this.handleQuery();
            },

            //ChangeStatus(value) {
            //    this.SearchType = value;
            //    if (value == 9) {
            //        this.ShowDelivery = true;
            //    } else {
            //        this.ShowDelivery = false;
            //    }
            //},

            //获取所有商品
            handleAllCouriers() {
                let para = {
                };
                this.listLoading = true;

                //NProgress.start();
                getAllCourier(para).then((res) => {
                    this.allCouriers = res.data.response;
                    this.listLoading = false;
                    //NProgress.done();
                });
            },
            //获取用户列表
            handleQuery() {
                var userId = "0";
                if (this.SelUserName == null || this.SelUserName == "" || isNaN(this.SelUserName) || Number(this.SelUserName) < 0) {
                    userId = "0";
                } else {
                    userId = this.SelUserName;
                }
                let para = {
                    page: this.page,
                    key: this.searchVal,//this.filters.name,
                    CourierId: this.SelCourierId,
                    Status: this.SelStatus,
                    PayType: this.SelPayType,
                    RefundType: this.SelRefundStatus,
                    IsSendInvoice: this.IsSendInvoice,
                    StartTime: this.StartTime,
                    EndTime: this.EndTime,
                    UserId: userId,
                    GoodsNameId: this.SelGoodsNames
                };
                this.listLoading = true;

                this.OrderStatistics = [];
                //NProgress.start();
                getOrderStatistics(para).then((res) => {
                    //this.total = res.data.response.dataCount;
                    //this.members = res.data.response;
                    //var orderList = res.data.response.data;
                    var members = {};
                    members.OrderCount = res.data.response.OrderCount;
                    members.AmountSum = res.data.response.AmountSum;
                    members.WeChatOrderCount = res.data.response.WeChatOrderCount;
                    members.WeChatAmountSum = res.data.response.WeChatAmountSum;
                    members.RechargeOrderCount = res.data.response.RechargeOrderCount;
                    members.RechargeAmountSum = res.data.response.RechargeAmountSum;
                    members.GoodsSum = res.data.response.GoodsSum;
                    this.OrderStatistics.push(members);


                    this.OrderStatisticsByCourierList = res.data.response.OrderStatisticsByCourierList;
                    this.OrderStatisticsByGoodsNameList = res.data.response.OrderStatisticsByGoodsNameList;
                    this.OrderStatisticsByStatusList = res.data.response.OrderStatisticsByStatusList;

                    //if (orderList != null && orderList.length > 0) {
                    //    for (var i = 0; i < orderList.length; i++) {
                    //        console.log(11);
                    //        console.log(orderList[i]);
                    //        console.log(orderList[i].UserInfo);
                    //        console.log(22);
                    //    }
                    //}
                    //if (orderList != null && orderList.length > 0) {
                    //    for (var i = 0; i < orderList.length; i++) {
                    //        if (orderList[i].Status >= 2) {
                    //            var labels = orderList[i].ClothesLabels;
                    //            if (labels != null && labels.length > 0) {
                    //                for (var j = 0; j < labels.length; j++) {
                    //                    var pictures = labels[j].ClothesPictures;
                    //                    if (pictures != null && pictures.length > 0) {
                    //                        for (var k = 0; k < pictures.length; k++) {
                    //                            var pInfo = pictures[k].Picture;
                    //                            if (pInfo != null && pInfo != "") {
                    //                                pictures[k].Picture = global.PictureDemain + pictures[k].Picture;
                    //                            }
                    //                        }
                    //                    }
                    //                }
                    //            }
                    //        }
                    //        var oproducts = orderList[i].OrderProductList;
                    //        console.log(oproducts);
                    //        if (oproducts != null && oproducts.length > 0) {
                    //            for (var j = 0; j < oproducts.length; j++) {
                    //                var coverImage = oproducts[j].ProductInfo.CoverImage;
                    //                if (coverImage != null && coverImage != "" && !coverImage.startsWith("http")) {
                    //                    oproducts[j].ProductInfo.CoverImage = global.PictureDemain + coverImage;
                    //                    console.log(global.PictureDemain + coverImage);
                    //                }
                    //                console.log(coverImage);
                    //            }
                    //        }
                    //    }
                    //}
                    //this.members = orderList;
                    this.listLoading = false;
                    //NProgress.done();
                });
            },
            ////导出excel
            //ExportExcel() {
            //    //let _this = this;
            //    var userId = "0";
            //    if (this.SelUserName == null || this.SelUserName == "" || isNaN(this.SelUserName) || Number(this.SelUserName) < 0) {
            //        userId = "0";
            //    } else {
            //        userId = this.SelUserName;
            //    }
            //    let para = {
            //        page: this.page,
            //        key: this.searchVal,//this.filters.name,
            //        StoreId: this.SelStoreId,
            //        CourierId: this.SelCourierId,
            //        Status: this.SelStatus,
            //        RefundType: this.SelRefundStatus,
            //        IsSendInvoice: this.IsSendInvoice,
            //        UserId: userId,
            //        StartTime: this.StartTime,
            //        EndTime: this.EndTime,
            //    };
            //    this.listLoading = true;
            //    //NProgress.start();
            //    exportOrderInfo(para).then(res => {
            //        //var blob = new Blob([res], { type: res.type });
            //        var blob = new Blob([res.data], { type: 'application/vnd.ms-excel;Charset=utf-8' })
            //        // 针对于IE浏览器的处理, 因部分IE浏览器不支持createObjectURL
            //        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            //            window.navigator.msSaveOrOpenBlob(res, `订单信息_${moment().format('YYYYMMDDHHmmss')}.xls`)
            //        } else {
            //            var downloadElement = document.createElement('a')
            //            var href = window.URL.createObjectURL(blob)
            //            // 创建下载的链接
            //            downloadElement.href = href;
            //            downloadElement.download = `订单信息_${moment().format('YYYYMMDDHHmmss')}.xls`;
            //            // 下载后文件名
            //            document.body.appendChild(downloadElement);
            //            downloadElement.click(); // 点击下载
            //            document.body.removeChild(downloadElement); // 下载完成移除元素
            //            window.URL.revokeObjectURL(href); // 释放掉blob对象
            //        }
            //    });
            //    this.listLoading = false;
            //},


            getAllTimePeriods() {
                let para = {
                };
                this.listLoading = true;

                //NProgress.start();
                getAllTimePeriod(para).then((res) => {
                    this.allTimePeriods = res.data.response;
                    this.listLoading = false;
                    //NProgress.done();
                });
            },

            getAllGoodsNameList(UserId) {
                let para = {
                    UserId: UserId,
                };
                this.listLoading = true;

                //NProgress.start();
                getAllGoodsName(para).then((res) => {
                    this.allGoodsNames = res.data.response;
                    this.listLoading = false;
                    //NProgress.done();
                });
            },
            getAllUserCouponList(UserId) {
                let para = {
                    UserId: UserId,
                };
                this.listLoading = true;

                //NProgress.start();
                getAllUserCoupon(para).then((res) => {
                    this.allUserCoupons = res.data.response;
                    this.listLoading = false;
                    //NProgress.done();
                });
            },

        },
        mounted() {

            let nowTime = new Date();
            let year = nowTime.getFullYear();
            let month = nowTime.getMonth() + 1;
            let day = nowTime.getDate();
            let endTime = `${year}-${month}-${day}`;

            let befDate = new Date(nowTime.getTime() - 7 * 24 * 3600 * 1000);
            let byear = befDate.getFullYear();
            let bmonth = befDate.getMonth() + 1;
            let bday = befDate.getDate();

            let startTime = `${byear}-${bmonth}-${bday}`;

            this.StartTime = startTime;
            //this.StartTime = endTime;
            this.EndTime = endTime;

            //获得所有预约时段
            this.getAllTimePeriods();
            this.handleAllCouriers();
            this.getAllGoodsNameList();
            //this.getAllUserAddress();

            this.handleQuery();

            let routers = window.localStorage.router
                ? JSON.parse(window.localStorage.router)
                : [];
            this.buttonList = getButtonList(this.$route.path, routers);
            this.buttonList.forEach(item => {
                console.log(item.Func);
                if (item.Func == "handleEdit") {
                    this.isEdit = true;
                }
                else if (item.Func == "handleDel") {
                    this.isDelete = true;
                }
                else if (item.Func == "handleExport") {
                    this.isExport = true;
                }
            });

            this.$nextTick(function () {
                //在页面渲染完成后
                this.tableHeight = window.innerHeight - this.$refs.table.$el.getBoundingClientRect().top - 50
                this.$refs.table.$el.getBoundingClientRect().top //表格距离浏览器的高度
                var that = this
                // 添加监听窗口大小变化事件
                window.onresize = function () {
                    that.tableHeight = window.innerHeight - that.$refs.table.$el.getBoundingClientRect().top - 50
                }
            })
        },
    };
</script>

<style scoped>
    .custom-tbl /deep/ .has-gutter .el-checkbox {
        display: none;
    }
</style>
<style>
    .vue-directive-image-previewer {
        z-index: 9999;
    }
</style>
